import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26.364",
  height: "40.455",
  viewBox: "0 0 29.317 33.291"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7860",
  d: "M5 27.9v-1.991A13.909 13.909 0 0 1 18.909 12h0a13.909 13.909 0 0 1 13.908 13.909V27.9",
  transform: "translate(-4.25 4.646)",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7861",
  d: "M15.948 19.9A7.948 7.948 0 1 0 8 11.948a7.948 7.948 0 0 0 7.948 7.952z",
  transform: "translate(-1.289 -3.25)",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };